import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withFormik } from 'formik';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { bindPromiseCreators, promisifyRoutine } from 'redux-saga-routines';

import { RegisterForm } from './registerForm.component';
import { RegisterSchema, defaultValues } from './registerForm.constants';
import { registerRoutine } from '../../../modules/auth/auth.redux';
import { OverlayActions } from '../../../modules/overlay';
import { AuthActions } from '../../../modules/auth';

export const registerRoutinePromiseCreator = promisifyRoutine(registerRoutine);

const mapStateToProps = createStructuredSelector({});

export const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      showTerms: OverlayActions.showTerms,
      hideModal: AuthActions.hideModal,
    },
    dispatch
  ),
  ...bindPromiseCreators({ registerRoutinePromiseCreator }, dispatch),
});

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter,
  withFormik({
    mapPropsToValues: () => defaultValues,
    handleSubmit: async (data, { props, ...formik }) => {
      try {
        formik.setSubmitting(true);

        await props.registerRoutinePromiseCreator(data);
      } catch ({ errors }) {
        formik.setErrors(errors);
      } finally {
        formik.setSubmitting(false);
      }
    },
    validationSchema: () => RegisterSchema,
  })
)(RegisterForm);
